import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { pick } from '@eastcoal/common/utils/object'

import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { DatePicker } from '@eastcoal/formily/components/DatePicker'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

const schema: SchemaItem[] = [
  {
    name: 'timingPublishTime',
    type: 'string',
    title: '发布时间',
    required: true,
    'x-component': DatePicker,
    'x-component-props': {
      showTime: true,
      format: 'YYYY-MM-DD HH:mm'
    },
    'x-decorator': FormItem
  }
]

export const SubmitScheduleButton = () => {
  const { form: parentForm, submit } = useCrudFormStore(state =>
    pick(state, ['form', 'submit'])
  )
  const form = useCreationForm()

  const handleConfirm = () => {
    form.submit(values => {
      parentForm.setValues(values)
      submit({ submitType: SubmitType.SUBMIT, keepon: false })
    })
  }

  return (
    <ConfirmButton
      warning
      confirmIcon={null}
      placement='top'
      type='primary'
      message={
        <SchemaForm
          form={form}
          name='announcementPublishScheduleForm'
          schema={schema}
          layout={{
            layout: 'vertical'
          }}
        />
      }
      onConfirm={handleConfirm}
    >
      定时发布
    </ConfirmButton>
  )
}
